export default {
  init() {
    $('.wdgk_donation_content input').attr('placeholder', 'Amount');
    $('.wdgk_donation_content').prepend('<p style="margin:0">Add a donation?</p>');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerceCart.js